<!-- <app-new-credit-claim-photo-upload-modal (newItemEvent)="receiveMessage($event)"></app-new-credit-claim-photo-upload-modal> -->
<section class="container new-credit-claim">
  @if (confirmationView || reasonView) {
    <a
      class="btn btn-action btn-small btn-back"
      [routerLink]="{ cxRoute: 'creditClaims' } | cxUrl"
      >
      <i class="fas fa-arrow-left mr-1"></i>
      {{ 'shared.backTo.creditClaims' | cxTranslate }}
    </a>
  }
  <!-- <div>Message: {{message}}</div> -->
  <mat-card class="new-credit-claim__header">
    <div class="new-credit-claim__section">
      <div class="new-credit-claim__section__content">
        <div class="row agreement-detail-content">
          @if (confirmView) {
            <div class="col-2 col-md-2 col-lg-2">
              <b>{{ 'shared.orderNumber' | cxTranslate }}</b>
            </div>
          }
          @if (confirmView) {
            <div class="col-10 col-md-10 col-lg-10">
              <span>{{ orderCode }}</span>
            </div>
          }
          <!-- <ng-container *ngIf="(isPickupObservable | async) == true">
          <div class="col-2 col-md-2 col-lg-2">
            <b>{{ "shared.reason" | cxTranslate }}</b>
          </div>
          <div class="col-10 col-md-10 col-lg-10">
            <span>{{ "creditClaims.reasons." + claimReasonForm.get('claimReasonControl').value | cxTranslate }}</span>
            <span class="update-reason">
              <i class="fas fa-pen" (click)="onReasonEditClicked()"></i>
            </span>
          </div>
        </ng-container> -->
        <!-- <ng-container *ngIf="requestReturnStockReason">
        <div class="col-2 col-md-2 col-lg-2">
          <b>{{ "shared.reason" | cxTranslate }}</b>
        </div>
        <div class="col-10 col-md-10 col-lg-10">
          <span>{{ "creditClaims.reasons." + claimReasonForm.get('claimReasonControl').value | cxTranslate }}</span>
          <span class="update-reason">
            <i class="fas fa-pen" (click)="onReasonEditClicked()"></i>
          </span>
        </div>
      </ng-container> -->
      <!-- <ng-container *ngIf="otherClaimReason">
      <div class="col-2 col-md-2 col-lg-2">
        <b>{{ "shared.reason" | cxTranslate }}</b>
      </div>
      <div class="col-10 col-md-10 col-lg-10">
        <span>{{ "creditClaims.reasons." + claimReasonForm.get('claimReasonControl').value | cxTranslate }}</span>
        <span class="update-reason">
          <i class="fas fa-pen" (click)="onReasonEditClicked()"></i>
        </span>
      </div>
    </ng-container> -->
    @if (shortAndOverSuppliedReason) {
      <div class="col-2 col-md-2 col-lg-2">
        <b>{{ 'shared.reason' | cxTranslate }}</b>
      </div>
      <div class="col-10 col-md-10 col-lg-10">
        <span>{{ shortAndOverSupplied }}</span>
        <span>{{ reasonChange }}</span>
        @if (reasonShortOnetime) {
          <span>
            {{ reasonChangeforShort }}
          </span>
        }
        @if (reasonFlag) {
          <span> </span>
        }
        <!-- <span class="update-reason">
        <i class="fas fa-pen" (click)="onReasonEditClicked()"></i>
      </span> -->
    </div>
  }
  @if (reasonView) {
    <div class="col-2 col-md-2 col-lg-2">
      <b>{{ 'shared.name' | cxTranslate }}</b>
    </div>
    <div class="col-10 col-md-10 col-lg-10">
      @if (user$ | async; as user) {
        <span>{{ user.name }}</span>
      }
    </div>
    <div class="col-2 col-md-2 col-lg-2">
      <b>{{ 'shared.email' | cxTranslate }}</b>
    </div>
    <div class="col-10 col-md-10 col-lg-10">
      @if (user$ | async; as user) {
        <span>{{ user.uid }}</span>
      }
    </div>
  }
  @if (defaultHeaderWithReason) {
    <div class="col-2 col-md-2 col-lg-2">
      <b>{{ 'shared.reason' | cxTranslate }} </b>
    </div>
    <div class="col-10 col-md-10 col-lg-10">
      <span>{{ 'creditClaims.reasons.' + claimReasonForm.get('claimReasonControl').value | cxTranslate }}</span>
      <span class="update-reason">
        <i class="fas fa-pen" (click)="onReasonEditClicked()"></i>
      </span>
    </div>
  }
  <div></div>
  <!-- <ng-container *ngIf="invoiceView"> -->
  <!-- <div class="col-12 text-right" *ngIf="!damagedStockAddCommentBtn && !otherDefaultReview">   -->
  @if (addComment) {
    <div class="col-12 text-right">
      <button class="btn btn-primary btn-small" type="button" (click)="onPhotoClicked()">
        {{ 'shared.addComment' | cxTranslate }}
      </button>
    </div>
  }
  <!-- <div class="col-12 text-right" *ngIf="damagedStockAddCommentBtn && !otherDefaultReview"> -->
  @if (addPhotoOrComment) {
    <div class="col-12 text-right">
      <button class="btn btn-primary btn-small" type="button" (click)="onPhotoClicked()">
        {{ 'shared.addPhotoOrComment' | cxTranslate }}
      </button>
    </div>
  }
  <!-- <div class="col-12 text-right" *ngIf="otherDefaultReview">
  <button class="btn btn-primary btn-small" type="button" (click)="onPhotoClicked()">
    {{"shared.addPhotoOrComment" | cxTranslate}}
  </button>
</div>  -->
<!-- </ng-container> -->
@if (shortAndOverSuppliedMsg) {
  <div class="col-12">
    <label for="">Step 1 Complete the following to confirm the items you were short supplied</label>
  </div>
}
@if (confirmationView) {
  <div class="col-12 confirmation">
    <div class="confirmation__message">
      <p>{{ 'creditClaims.successMessage' | cxTranslate }}</p>
    </div>
    <div class="col-12 col-md-12 col-lg-12" id="oNum">
      <span
        ><b>{{ 'shared.orderNumber' | cxTranslate }}</b></span
        >
        <span class="oCode">{{ orderCode }}</span>
      </div>
      <div class="confirmation__message">
        <p>{{ 'creditClaims.referenceNote' | cxTranslate }}</p>
      </div>
      <!-- <span>={{this.submittedReason}}</span>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <span>{{this.submittedTicket}}</span> -->
      <!-- <span>{{ "creditClaims.reasons." + this.submittedReason | cxTranslate }}</span>
      <span style="margin-left:60px;">{{this.submittedTicket}}</span> -->
      @if (ShortOverSuppliedRelatedTicketId) {
        <div>
          <span>{{ 'creditClaims.reasons.' + this.submittedReason | cxTranslate }}</span>
          <span style="margin-left: 60px">{{ this.submittedTicket }}</span>
          <div>
            <span>Short supplied</span>
            <span style="margin-left: 60px">{{ this.submittedRelatedTicketId }}</span>
          </div>
        </div>
      }
      @if (onlyTicketId) {
        <div>
          <span>{{ 'creditClaims.reasons.' + this.submittedReason | cxTranslate }}</span>
          <span style="margin-left: 60px">{{ this.submittedTicket }}</span>
        </div>
      }
      @if (onlyRelatedTicketId) {
        <div>
          <span>Short supplied</span>
          <span style="margin-left: 60px">{{ this.submittedRelatedTicketId }}</span>
        </div>
      }
      <div class="confirmation__message" id="onum">
        <p>
          {{ 'creditClaims.confirmationMessage' | cxTranslate }}
          @if (user$ | async; as user) {
            <span>{{ user.uid }}</span>
          }
        </p>
      </div>
      <div class="confirmation__message">
        <p>{{ 'creditClaims.checkStatus' | cxTranslate }}</p>
      </div>
    </div>
  }
</div>
</div>
</div>
</mat-card>
@if (reasonView) {
  <mat-card class="new-credit-claim__body">
    <h3 class="new-credit-claim__body__title">
      {{ 'creditClaims.reasonForClaim' | cxTranslate }}
    </h3>
    <div class="new-credit-claim__body__section">
      <div class="new-credit-claim__body__section__content">
        <form [formGroup]="claimReasonForm">
          @for (claimReason of claimReasons | sortBy: 'asc' : 'order'; track claimReason) {
            <div
              class="form-check col-6 col-md-6 col-lg-6"
              >
              @if (
                claimReason.name !== 'ASALEO_KEYING_DISCREPANCY' &&
                claimReason.name !== 'EXPIRED_STOCK' &&
                claimReason.name !== 'RECEIVED_DAMAGED'
                ) {
                <div
                  class=""
                  >
                  <input
                    id="{{ claimReason.name }}"
                    class="form-check-input"
                    role="radio"
                    type="radio"
                    aria-checked="false"
                    [value]="claimReason.name"
                    [checked]="false"
                    formControlName="claimReasonControl"
                    />
                    <label class="cx-payment-type-label form-check-label form-radio-label" for="{{ claimReason }}">
                      <div class="cx-payment-type">
                        {{ 'creditClaims.reasons.' + claimReason.name | cxTranslate }}
                        @if (
                          claimReason.name === 'DAMAGED_STOCK' ||
                          claimReason.name === 'REQUEST_RETURN' ||
                          claimReason.name === 'OTHER' ||
                          claimReason.name === 'FAULTY_STOCK'
                          ) {
                          <span
                            >
                            <i
                              class="fas fa-asterisk"
                              id="asterisk"
                              ngbPopover=" {{ 'creditClaims.reasonPhotoMessage' | cxTranslate }}"
                              triggers="mouseenter:mouseleave"
                              id="asterisk"
                            ></i>
                          </span>
                        }
                        @if (claimReason.name === 'SHORT_OVER_SUPPLIED') {
                          <span>
                            <i
                              class="fas fa-question-circle"
                              ngbPopover=" {{ 'creditClaims.shortAndOverSuppliedTip' | cxTranslate }}"
                              triggers="mouseenter:mouseleave"
                            ></i>
                          </span>
                        }
                        @if (
                          claimReason.name === 'DAMAGED_STOCK' ||
                          claimReason.name === 'FAULTY_STOCK' ||
                          claimReason.name === 'OTHER'
                          ) {
                          <span
                            >
                            <i
                              class="fas fa-question-circle"
                              ngbPopover=" {{ 'creditClaims.restockingFeeNote' | cxTranslate }}"
                              triggers="mouseenter:mouseleave"
                            ></i>
                          </span>
                        }
                      </div>
                    </label>
                  </div>
                }
              </div>
            }
          </form>
          <div class="action-button">
            <button
              class="btn btn-primary"
              type="submit"
              [disabled]="!claimReasonForm.valid"
              (click)="onReasonSelected($event, claimReasonForm.get('claimReasonControl').value)"
              >
              {{ 'common.continue' | cxTranslate }}
            </button>
          </div>
        </div>
      </div>
    </mat-card>
  }
  @if (invoiceView) {
    <mat-card class="new-credit-claim__body">
      <div class="new-credit-claim__body__section">
        <div class="new-credit-claim__body__section__content">
          <form [formGroup]="claimForm">
            <div class="new-credit-claim__body__section__content__table">
              @if (order && (isOverSuppliedPdt | async) != true) {
                <table class="table order-history-table">
                  <thead class="cx-order-history-thead-mobile">
                    <th scope="col">{{ 'creditClaims.order.material' | cxTranslate }}</th>
                    <th scope="col">{{ 'creditClaims.order.description' | cxTranslate }}</th>
                    <th scope="col">{{ 'creditClaims.order.deliveryDate' | cxTranslate }}</th>
                    <th scope="col">{{ 'creditClaims.order.orderedQTY' | cxTranslate }}</th>
                    <th scope="col">{{ 'creditClaims.order.deliveredQTY' | cxTranslate }}</th>
                    <th scope="col">{{ 'creditClaims.order.claimQTY' | cxTranslate }}</th>
                    <th scope="col">{{ 'creditClaims.order.claimValue' | cxTranslate }}</th>
                  </thead>
                  <tbody>
                    @for (orderEntry of customEntries; track orderEntry; let index = $index) {
                      <tr>
                        <td class="cx-order-history-code">
                          <p class="cx-order-history-value">{{ orderEntry?.product?.code }}</p>
                        </td>
                        <td class="cx-order-history-code">
                          <p class="cx-order-history-value">{{ orderEntry?.product?.name }}</p>
                        </td>
                        <td class="cx-order-history-code">
                          <p class="cx-order-history-value">{{ orderEntry?.deliveredDate | cxDate }}</p>
                        </td>
                        <td class="cx-order-history-code">
                          <p class="cx-order-history-value">{{ orderEntry?.quantity }}</p>
                        </td>
                        <td class="cx-order-history-code">
                          <p class="cx-order-history-value">{{ orderEntry?.deliveredQuantity }}</p>
                        </td>
                        <td class="cx-order-history-code">
                          <p class="cx-order-history-value">
                            <input
                              #TextInput
                              type="number"
                              class="form-control"
                              (change)="totalClaims($event, orderEntry)"
                              (keyup)="validateQuantity(TextInput.value, TextInput.max)"
                              (keydown.enter)="$event.preventDefault(); moveToNextInput(index)"
                              [formControlName]="orderEntry?.product?.code"
                              max="{{ orderEntry?.quantity }}"
                              min="0"
                              />
                            </p>
                          </td>
                          <td>
                            <!-- <p class="cx-order-history-value">
                            <input #numberData type="number" class="form-control" readOnly
                              [value]="!(isStockObservable | async) ?  (orderEntry?.basePrice?.value)*(TextInput.value): 0"
                              [formControlName]="orderEntry?.product?.code" />
                            </p>    -->
                            <p class="cx-order-history-value">
                              <input
                                #numberData
                                type="number"
                                class="form-control"
                                readOnly
                                [value]="orderEntry?.basePrice?.value * TextInput.value | customDecimal"
                                [formControlName]="orderEntry?.product?.code"
                                />
                              </p>
                            </td>
                          </tr>
                        }
                        <!-- [(ngModel)]="isOverSuppliedPdt ? value[(orderEntry?.basePrice?.value)*(TextInput.value)] : value[0]" -->
                        <!-- [(ngModel)]="values[isOverSuppliedPdt ? '(orderEntry?.basePrice?.value)*(TextInput.value)' : '0'" -->
                      </tbody>
                    </table>
                  }
                  @if ((isOverSuppliedPdt | async) == true) {
                    <table class="table order-history-table">
                      <thead class="cx-order-history-thead-mobile">
                        <th scope="col">{{ 'creditClaims.order.material' | cxTranslate }}</th>
                        <th scope="col">{{ 'creditClaims.order.description' | cxTranslate }}</th>
                        <th scope="col">{{ 'creditClaims.order.claimQTY' | cxTranslate }}</th>
                        <th scope="col">{{ 'creditClaims.order.claimValue' | cxTranslate }}</th>
                      </thead>
                      <tbody formArrayName="matData">
                        @for (passGroup of matData?.controls; track passGroup; let i = $index) {
                          <tr [formGroupName]="i">
                            <td class="cx-order-history-code">
                              <mat-form-field floatLabel="never">
                                <input
                                  type="text"
                                  (focus)="checkPlaceHolder()"
                                  (blur)="checkPlaceHolder()"
                                  placeholder="{{ myplaceHolder }}"
                                  matInput
                                  placeholder="Search"
                                  formControlName="materialCode"
                                  [matAutocomplete]="auto"
                                  (ngModelChange)="onSelectionChanged($event, i)"
                                  />
                                  <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                                    @for (materialCode of filteredCompanies | async; track materialCode) {
                                      <mat-option [value]="materialCode">
                                        {{ materialCode.code }}-{{ materialCode.name }}
                                      </mat-option>
                                    }
                                  </mat-autocomplete>
                                </mat-form-field>
                              </td>
                              <td>
                                <input type="text" matInput formControlName="itemDesc" />
                              </td>
                              <td class="cx-order-history-code">
                                <!-- (keyup)="validateQuantity(TextInput1.value, TextInput1.max)" -->
                                <p class="cx-order-history-value">
                                  <input
                                    #TextInput1
                                    type="number"
                                    class="form-control"
                                    (keydown.enter)="$event.preventDefault(); moveToNextInput(index)"
                                    formControlName="materialQuantity"
                                    max="{{ orderEntry?.quantity }}"
                                    min="0"
                                    />
                                  </p>
                                </td>
                                <td>
                                  <p class="cx-order-history-value">
                                    <input type="number" class="form-control" readOnly [value]="0" [formControlName]="total" />
                                  </p>
                                </td>
                              <!-- </ng-container> -->
                            </tr>
                          }
                        <!-- </ng-container> -->
                      <!-- </tbody> -->
                    </tbody>
                  </table>
                  @if (addItembtn) {
                    <div>
                      <button (click)="addItem()" id="additem" class="btn back-button btn-action">Add Item</button>
                    </div>
                  }
                }
              </div>
              @if (order && (isOverSuppliedPdt | async) != true) {
                <div class="row">
                  <div class="col"></div>
                  <div class="col">
                    <div class="row">
                      <div class="col text-center">
                        <b>Total (EX GST):</b>
                      </div>
                      <div class="col text-right">${{ claimValue }}</div>
                    </div>
                  </div>
                </div>
              }
              @if (isInstead) {
                <div class="row">
                  <div class="col">
                    <div class="row">
                      <div class="col">
                        <b>{{ 'creditClaims.didYouReceive' | cxTranslate }}</b>
                      </div>
                      <div class="col-auto">
                        <div class="row">
                          <div class="form-group mr-15">
                            <div class="form-check">
                              <input
                                type="radio"
                                class="form-check-input"
                                aria-checked="false"
                                [disabled]="isDisabled"
                                value="Yes"
                                [checked]="false"
                                name="cclaims"
                                id="defaultCheck2"
                                (change)="openModel($event, claimReasonForm.get('claimReasonControl').value)"
                                />
                                <label class="form-check-label" for="defaultCheck2">{{
                                  'creditClaims.yes' | cxTranslate
                                }}</label>
                              </div>
                            </div>
                            <div class="form-group" id="creditClaimYesNo">
                              <div class="form-check">
                                <input
                                  type="radio"
                                  class="form-check-input"
                                  aria-checked="false"
                                  [disabled]="isDisabled"
                                  value="No"
                                  name="cclaims"
                                  [checked]="false"
                                  id="defaultCheck3"
                                  (change)="reviewedClaimNo($event)"
                                  />
                                  <label class="form-check-label" for="defaultCheck3">{{
                                    'creditClaims.no' | cxTranslate
                                  }}</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col"></div>
                    </div>
                  }
                  @if (shortAndOverSuppliedMsg) {
                    <div class="col-12">
                      <div class="form-group row">
                        <div class="col-12 form-check d-block text-right">
                          <input
                            class="form-check-input"
                            type="checkbox"
                            value=""
                            id="defaultCheck6"
                            [disabled]="isDisabled"
                            (click)="openModel($event, claimReasonForm.get('claimReasonControl').value)"
                            />
                            <label class="form-check-label" for="defaultCheck6"
                              >Yes, I Have entered all items short supplied and am happy to proceed to submit the oversupplied
                              items.</label
                              >
                            </div>
                          </div>
                        </div>
                      }
                      @if ((isStockObservable | async) == true) {
                        <div class="row">
                          <div class="col-lg-4 col-md-4">
                            <b>Would you like to keep the stock?</b>
                          </div>
                          <div class="col-auto">
                            <div class="row" id="StockYN">
                              <div class="form-group mr-15">
                                <div class="form-check">
                                  <input
                                    type="radio"
                                    class="form-check-input"
                                    aria-checked="false"
                                    value="Yes"
                                    [disabled]="isDisabled"
                                    [checked]="false"
                                    name="cclaims"
                                    id="defaultCheck4"
                                    (change)="purchaseOrderNumber($event, claimReasonForm.get('claimReasonControl').value)"
                                    />
                                    <label class="form-check-label" for="defaultCheck4">{{ 'creditClaims.yes' | cxTranslate }}</label>
                                  </div>
                                </div>
                                <div class="form-group" id="creditClaimYesNo">
                                  <div class="form-check">
                                    <input
                                      type="radio"
                                      class="form-check-input"
                                      name="cclaims"
                                      aria-checked="false"
                                      [disabled]="isDisabled"
                                      value="No"
                                      [checked]="false"
                                      id="defaultCheck5"
                                      (change)="purchaseOrderNumberNo($event, claimReasonForm.get('claimReasonControl').value)"
                                      />
                                      <label class="form-check-label" for="defaultCheck5">{{ 'creditClaims.no' | cxTranslate }}</label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="col"></div>
                            </div>
                          }
                          @if (damagedStockAddCommentMsg) {
                            <div>
                              We will review your claim and advise if we require any further information. Please set the stock aside
                              ready for further instructions.
                            </div>
                          }
                          @if (damagedStockAddCommentBtn) {
                            <div class="col-12">
                              <div class="form-group row">
                                <div class="col-12 form-check d-block text-right">
                                  <input
                                    class="form-check-input"
                                    type="checkbox"
                                    value="Yes"
                                    id="defaultCheck12"
                                    (change)="damagedStockDefaultYes()"
                                    />
                                    <label class="form-check-label" for="defaultCheck12">{{
                                      'creditClaims.reviewed' | cxTranslate
                                    }}</label>
                                  </div>
                                </div>
                              </div>
                            }
                            @if (isPurchaseOrderNumber) {
                              <div class="row">
                                <div class="col-12">
                                  <b>Please enter the Purchase Order number you would like us to reference on the invoice (required): </b>
                                </div>
                                <div class="col-auto d-flex" id="purchaseOrderNumber">
                                  <b>Enter Purchase Order Number:</b
                                    ><input type="text" class="form-control" [value]="" formControlName="orderNumber" />
                                    <cx-form-errors [control]="claimForm.get('orderNumber')"></cx-form-errors>
                                  </div>
                                </div>
                              }
                              @if (overSuppliedInstead) {
                                <div class="row">
                                  <div class="col">
                                    <div class="row">
                                      <div class="col">
                                        <b>Were you short supplied something else instead?</b>
                                      </div>
                                      <div class="col-auto">
                                        <div class="row">
                                          <div class="form-group mr-15">
                                            <div class="form-check">
                                              <input
                                                type="radio"
                                                class="form-check-input"
                                                aria-checked="false"
                                                value="Yes"
                                                [checked]="false"
                                                (click)="secondCliamModel($event, claimReasonForm.get('claimReasonControl').value)"
                                                name="cclaims"
                                                id="defaultCheck2"
                                                (change)="onOverSuppliedInsteadYes($event)"
                                                />
                                                <label class="form-check-label" for="defaultCheck2">{{
                                                  'creditClaims.yes' | cxTranslate
                                                }}</label>
                                              </div>
                                            </div>
                                            <div class="form-group" id="creditClaimYesNo">
                                              <div class="form-check">
                                                <input
                                                  type="radio"
                                                  class="form-check-input"
                                                  aria-checked="false"
                                                  value="No"
                                                  name="isreviewaccept"
                                                  [checked]="false"
                                                  id="defaultCheck3"
                                                  (change)="onOverSuppliedInsteadNo($event)"
                                                  />
                                                  <label class="form-check-label" for="defaultCheck3">{{
                                                    'creditClaims.no' | cxTranslate
                                                  }}</label>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="col"></div>
                                    </div>
                                  }
                                  @if (isReview) {
                                    <div class="col-12">
                                      <div class="form-group row">
                                        <div class="col-12 form-check d-block text-right">
                                          <input
                                            formControlName="accept"
                                            class="form-check-input"
                                            type="checkbox"
                                            value=""
                                            id="defaultCheck1"
                                            />
                                            <label class="form-check-label" for="defaultCheck1">{{
                                              'creditClaims.reviewed' | cxTranslate
                                            }}</label>
                                          </div>
                                        </div>
                                        <div class="action-button">
                                          <!-- <button class="btn back-button btn-action" type="button" (click)="onBackClicked()">
                                          {{ "common.back" | cxTranslate }}
                                        </button> -->
                                        <button
                                          class="btn btn-primary"
                                          type="submit"
                                          [disabled]="claimForm.invalid"
                                          (click)="onNewClaimSubmit()"
                                          >
                                          @if (spinner) {
                                            <i class="fa fa-spinner fa-spin"></i>
                                          }
                                          {{ 'common.submit' | cxTranslate }}
                                        </button>
                                      </div>
                                    </div>
                                  }
                                  @if (dateOlderThreeMonths) {
                                    <div>
                                      Request to return stock delivered 3 months and older is not allowed.
                                      <div class="action-button">
                                        <button class="btn back-button btn-action" type="button" (click)="onBackClicked()">
                                          {{ 'common.back' | cxTranslate }}
                                        </button>
                                      </div>
                                    </div>
                                  }
                                  @if (notThreemonthOld) {
                                    <div>
                                      <div class="form-group row">
                                        <div class="col-12 form-check d-block text-right">
                                          <input
                                            formControlName="accept"
                                            class="form-check-input"
                                            type="checkbox"
                                            (change)="reviewedBtnChecked($event)"
                                            value=""
                                            id="defaultCheck18"
                                            />
                                            <label class="form-check-label" for="defaultCheck18">{{
                                              'creditClaims.reviewed' | cxTranslate
                                            }}</label>
                                          </div>
                                        </div>
                                      </div>
                                    }
                                    @if (otherDefaultReview) {
                                      <div class="col-12">
                                        <div class="form-group row">
                                          <div class="col-12 form-check d-block text-right">
                                            <input
                                              class="form-check-input"
                                              type="checkbox"
                                              value="Yes"
                                              id="defaultCheck12"
                                              (change)="otherReasonReview($event)"
                                              />
                                              <label class="form-check-label" for="defaultCheck12"
                                                >{{ 'creditClaims.reviewed' | cxTranslate }}
                                              </label>
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    </form>
                                  </div>
                                </div>
                              </mat-card>
                            }
                            @if (reqReturnStockPanel) {
                              <mat-card class="new-credit-claim__body">
                                <div class="new-credit-claim__body__section">
                                  <div class="new-credit-claim__body__section__content mr-2">
                                    @if (dateWithinThreeMonths) {
                                      <div>
                                        <p>
                                          Please note, we will review your claim and will advice you if we require any further information or next
                                          steps as we may require the product to be returned back.
                                        </p>
                                        <!-- <div class="row">
                                        <div class="col-lg-8 col-md-8">
                                          <b>Would you like to arrange the return of stock yourself?</b>
                                          !-- <b>Is stock required to be returned, Would you like to arrange the return of stock yourself?</b> --
                                        </div>
                                        <div class="col-auto">
                                          <div class="row">
                                            <div class="form-group">
                                              <div class="form-check mr-15">
                                                <input type="radio" class="form-check-input" aria-checked="false" value="Yes" [checked]="false"
                                                  name="cclaims" id="defaultCheck14" (change)="returnStockYes($event)">
                                                  <label class="form-check-label" for="defaultCheck14">{{ "creditClaims.yes" | cxTranslate
                                                  }}</label>
                                                </div>
                                              </div>
                                              <div class="form-group">
                                                <div class="form-check">
                                                  <input type="radio" class="form-check-input" name="cclaims" aria-checked="false" value="No"
                                                    [checked]="false" id="defaultCheck17" (change)="returnStockNo($event)">
                                                    <label class="form-check-label" for="defaultCheck17">{{ "creditClaims.no" | cxTranslate
                                                    }}</label>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="col"></div>
                                          </div> -->
                                        </div>
                                      }
                                      @if (reStockFees) {
                                        <div class="row">
                                          <div class="col-lg-6 col-md-6">
                                            <b>Restocking fees will apply, please confirm acceptance?</b>
                                          </div>
                                          <div class="col-auto">
                                            <div class="row">
                                              <div class="form-group">
                                                <div class="form-check mr-15">
                                                  <input
                                                    type="radio"
                                                    class="form-check-input"
                                                    aria-checked="false"
                                                    value="Yes"
                                                    [checked]="false"
                                                    name="cclaimse"
                                                    id="defaultCheck19"
                                                    (change)="restockFeesYes($event)"
                                                    />
                                                    <label class="form-check-label" for="defaultCheck19">{{ 'creditClaims.yes' | cxTranslate }}</label>
                                                  </div>
                                                </div>
                                                <div class="form-group">
                                                  <div class="form-check">
                                                    <input
                                                      type="radio"
                                                      class="form-check-input"
                                                      name="cclaimse"
                                                      aria-checked="false"
                                                      value="No"
                                                      [checked]="false"
                                                      id="defaultCheck20"
                                                      (change)="restockFeesNo($event)"
                                                      />
                                                      <label class="form-check-label" for="defaultCheck20">{{ 'creditClaims.no' | cxTranslate }}</label>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                              <div class="col"></div>
                                            </div>
                                          }
                                          <form [formGroup]="stockForm">
                                            @if (returnStockReviewed) {
                                              <div class="col-12">
                                                <div class="col-12">
                                                  <div class="form-group row">
                                                    <div class="col-12 form-check d-block text-right">
                                                      <input
                                                        formControlName="stockaccept"
                                                        class="form-check-input"
                                                        type="checkbox"
                                                        value="Yes"
                                                        id="defaultCheck13"
                                                        />
                                                        <label class="form-check-label" for="defaultCheck13">{{
                                                          'creditClaims.reviewed' | cxTranslate
                                                        }}</label>
                                                      </div>
                                                    </div>
                                                    <div class="action-button">
                                                      <!-- <button class="btn back-button btn-action" type="button" (click)="onBackClicked()">
                                                      {{ "common.back" | cxTranslate }}
                                                    </button> -->
                                                    <button
                                                      class="btn btn-primary"
                                                      type="submit"
                                                      [disabled]="stockForm.invalid"
                                                      (click)="onNewClaimSubmit()"
                                                      >
                                                      @if (spinner) {
                                                        <i class="fa fa-spinner fa-spin"></i>
                                                      }
                                                      {{ 'common.submit' | cxTranslate }}
                                                    </button>
                                                  </div>
                                                </div>
                                              </div>
                                            }
                                          </form>
                                        </div>
                                      </div>
                                    </mat-card>
                                  }
                                  @if (otherReasonReviewed) {
                                    <mat-card class="new-credit-claim__body">
                                      <div class="new-credit-claim__body__section">
                                        <div class="new-credit-claim__body__section__content mr-2">
                                          <p>
                                            Please note, we will review your claim and will advice you if we require any further information or next
                                            steps as we may require the product to be returned back.
                                          </p>
                                          <form [formGroup]="otherReasonForm">
                                            <div class="row">
                                              <div class="col-lg-8 col-md-8">
                                                <b>Is stock required to be returned, Would you like to arrange the return of stock yourself?</b>
                                              </div>
                                              <div class="col-auto">
                                                <div class="row">
                                                  <div class="form-group">
                                                    <div class="form-check mr-15">
                                                      <input
                                                        type="radio"
                                                        class="form-check-input"
                                                        aria-checked="false"
                                                        value="Yes"
                                                        [checked]="false"
                                                        name="otherreasonyes"
                                                        id="defaultCheck15"
                                                        (change)="otherReasonisStockYes($event)"
                                                        />
                                                        <label class="form-check-label" for="defaultCheck15">{{
                                                          'creditClaims.yes' | cxTranslate
                                                        }}</label>
                                                      </div>
                                                    </div>
                                                    <div class="form-group">
                                                      <div class="form-check">
                                                        <input
                                                          type="radio"
                                                          class="form-check-input"
                                                          name="otherreasonyes"
                                                          aria-checked="false"
                                                          value="No"
                                                          [checked]="false"
                                                          id="defaultCheck16"
                                                          (change)="otherReasonisStockNo($event)"
                                                          />
                                                          <label class="form-check-label" for="defaultCheck16">{{ 'creditClaims.no' | cxTranslate }}</label>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="col"></div>
                                                </div>
                                                @if (otherReasonIsStockReview) {
                                                  <div class="col-12">
                                                    <div class="form-group row">
                                                      <div class="col-12 form-check d-block text-right">
                                                        <input
                                                          formControlName="otherReasonReviewCheck"
                                                          class="form-check-input"
                                                          type="checkbox"
                                                          value="Yes"
                                                          id="defaultCheck12"
                                                          />
                                                          <label class="form-check-label" for="defaultCheck12">{{
                                                            'creditClaims.reviewed' | cxTranslate
                                                          }}</label>
                                                        </div>
                                                      </div>
                                                      <div class="action-button">
                                                        <!-- <button class="btn back-button btn-action" type="button" (click)="onBackClicked()">
                                                        {{ "common.back" | cxTranslate }}
                                                      </button> -->
                                                      <button
                                                        class="btn btn-primary"
                                                        type="submit"
                                                        (click)="onNewClaimSubmit()"
                                                        [disabled]="otherReasonForm.invalid"
                                                        >
                                                        @if (spinner) {
                                                          <i class="fa fa-spinner fa-spin"></i>
                                                        }
                                                        {{ 'common.submit' | cxTranslate }}
                                                      </button>
                                                    </div>
                                                    @if (
                                                      claimReasonForm.get('claimReasonControl').value == 'DAMAGED_STOCK' ||
                                                      claimReasonForm.get('claimReasonControl').value == 'FAULTY_STOCK' ||
                                                      claimReasonForm.get('claimReasonControl').value == 'REQUEST_RETURN' ||
                                                      claimReasonForm.get('claimReasonControl').value == 'OTHER'
                                                      ) {
                                                      <div
                                                        >
                                                        <p><span style="font-weight: 900"> * </span> Please add a photo and comments</p>
                                                      </div>
                                                    }
                                                    @if (
                                                      claimReasonForm.get('claimReasonControl').value == 'SHORT_SUPPLIED' ||
                                                      claimReasonForm.get('claimReasonControl').value == 'OVER_SUPPLIED' ||
                                                      claimReasonForm.get('claimReasonControl').value == 'SHORT_OVER_SUPPLIED'
                                                      ) {
                                                      <div
                                                        >
                                                        <p><span style="font-weight: 900"> * </span> Please add comments.</p>
                                                      </div>
                                                    }
                                                  </div>
                                                }
                                              </form>
                                            </div>
                                          </div>
                                        </mat-card>
                                      }
                                      @if ((isPickupObservable | async) == true) {
                                        <mat-card class="new-credit-claim__body">
                                          <div class="new-credit-claim__body__section">
                                            <div class="new-credit-claim__body__section__content mr-2">
                                              <div class="row pl-3">
                                                <b>Are the below details correct for the pickup address?</b>
                                                <div class="form-group ml-2">
                                                  <div class="form-check">
                                                    <input
                                                      class="form-check-input"
                                                      type="radio"
                                                      aria-checked="false"
                                                      name="pickup"
                                                      [checked]="false"
                                                      value="Yes"
                                                      id="defaultCheck9"
                                                      (change)="pickUpDetails($event, claimReasonForm.get('claimReasonControl').value)"
                                                      />
                                                      <label class="form-check-label" for="defaultCheck9">Yes</label>
                                                    </div>
                                                  </div>
                                                  <div class="form-group" id="creditClaimYesNo">
                                                    <div class="form-check">
                                                      <input
                                                        class="form-check-input"
                                                        type="radio"
                                                        aria-checked="false"
                                                        [checked]="false"
                                                        name="pickup"
                                                        value="No"
                                                        id="defaultCheck10"
                                                        (change)="updateCollection($event)"
                                                        />
                                                        <label class="form-check-label" for="defaultCheck10">No</label>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div>
                                                    <b>Requester Name:</b><span> {{ userlog.name }}</span>
                                                    <!-- <b>Requester Name:</b><span> Khawaja</span> -->
                                                  </div>
                                                  <div class="spaceCompany">
                                                    <b>Company Name:</b>&nbsp;<span>{{ userlog.orgUnit.name }}</span>
                                                    <!-- <b>Company Name:</b>&nbsp;<span>ABC</span> -->
                                                  </div>
                                                  <div style="margin-bottom: 30px">
                                                    <b>Pick up address:</b>
                                                    {{ order.deliveryAddress.formattedAddress }}
                                                    <!-- <div *ngFor="let address of addresses$ | async">
                                                    <div *ngIf="address.shippingAddress">
                                                      &nbsp;<span>{{ address.formattedAddress }}</span>
                                                      <!-- &nbsp;<span>Address 123</span>
                                                    </div>
                                                  </div> -->
                                                </div>
                                                <form [formGroup]="pickupForm">
                                                  @if (isUpdatedCollection) {
                                                    <div class="row">
                                                      <div class="col-12" id="correctDetails">
                                                        <b>Please advise of the correct details to be updated regarding this collection (required) </b>
                                                      </div>
                                                      <div class="col-auto d-flex" id="addressComments">
                                                        <b>Add address and comments</b>
                                                        <textarea
                                                          class="text-area form-control rounded-0"
                                                          formControlName="addressTextArea"
                                                          id="addressTextArea"
                                                          name="addressTextArea"
                                                        ></textarea>
                                                        <cx-form-errors [control]="pickupForm.get('addressTextArea')"></cx-form-errors>
                                                      </div>
                                                      <div class="col-12">
                                                        <div class="form-group row">
                                                          <div class="col-12 form-check d-block text-right">
                                                            <input
                                                              formControlName="updateaccept"
                                                              class="form-check-input"
                                                              type="checkbox"
                                                              value="Yes"
                                                              id="defaultCheck11"
                                                              />
                                                              <label class="form-check-label" for="defaultCheck11">{{
                                                                'creditClaims.reviewed' | cxTranslate
                                                              }}</label>
                                                            </div>
                                                          </div>
                                                          <div class="action-button">
                                                            <!-- <button class="btn back-button btn-action" type="button" (click)="onBackClicked()">
                                                            {{ "common.back" | cxTranslate }}
                                                          </button> -->
                                                          <button
                                                            class="btn btn-primary"
                                                            type="submit"
                                                            [disabled]="pickupForm.invalid"
                                                            (click)="onNewClaimSubmit()"
                                                            >
                                                            @if (spinner) {
                                                              <i class="fa fa-spinner fa-spin"></i>
                                                            }
                                                            {{ 'common.submit' | cxTranslate }}
                                                          </button>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  }
                                                  @if (isPickUpDetails) {
                                                    <div class="col-12">
                                                      <div class="form-group row">
                                                        <div class="col-12 form-check d-block text-right">
                                                          <input
                                                            formControlName="pickupaccept"
                                                            class="form-check-input"
                                                            type="checkbox"
                                                            value="Yes"
                                                            id="defaultCheck1"
                                                            />
                                                            <label class="form-check-label" for="defaultCheck1">{{
                                                              'creditClaims.reviewed' | cxTranslate
                                                            }}</label>
                                                          </div>
                                                        </div>
                                                        <div class="action-button">
                                                          <!-- <button class="btn back-button btn-action" type="button" (click)="onBackClicked()">
                                                          {{ "common.back" | cxTranslate }}
                                                        </button> -->
                                                        <button
                                                          class="btn btn-primary"
                                                          type="submit"
                                                          [disabled]="pickupForm.invalid"
                                                          (click)="onNewClaimSubmit()"
                                                          >
                                                          @if (spinner) {
                                                            <i class="fa fa-spinner fa-spin"></i>
                                                          }
                                                          {{ 'common.submit' | cxTranslate }}
                                                        </button>
                                                      </div>
                                                    </div>
                                                  }
                                                </form>
                                              </div>
                                            </div>
                                            @if (
                                              claimReasonForm.get('claimReasonControl').value == 'DAMAGED_STOCK' ||
                                              claimReasonForm.get('claimReasonControl').value == 'FAULTY_STOCK' ||
                                              claimReasonForm.get('claimReasonControl').value == 'REQUEST_RETURN' ||
                                              claimReasonForm.get('claimReasonControl').value == 'OTHER'
                                              ) {
                                              <div
                                                >
                                                <p><span style="font-weight: 900"> * </span> Please add a photo and comments</p>
                                              </div>
                                            }
                                            @if (
                                              claimReasonForm.get('claimReasonControl').value == 'SHORT_SUPPLIED' ||
                                              claimReasonForm.get('claimReasonControl').value == 'OVER_SUPPLIED' ||
                                              claimReasonForm.get('claimReasonControl').value == 'SHORT_OVER_SUPPLIED'
                                              ) {
                                              <div
                                                >
                                                <p><span style="font-weight: 900"> * </span> Please add comments.</p>
                                              </div>
                                            }
                                          </mat-card>
                                        }
                                        <mat-card class="new-credit-claim__footer">
                                          <div class="new-credit-claim__footer__contact">
                                            <h3 class="new-credit-claim__footer__contact--header">For Customer Enquiries:</h3>
                                            <p class="new-credit-claim__footer__contact--content">
                                              <strong>Telephone: </strong>
                                              <a href="tel:1800 643 634">1800 643 634</a>
                                              (within Australia)
                                            </p>
                                            <p class="new-credit-claim__footer__contact--content">
                                              <strong>Telephone: </strong>
                                              <a href="tel:0800 523 565">0800 523 565</a>
                                              (within New Zealand)
                                            </p>
                                            <p class="new-credit-claim__footer__contact--content">
                                              <strong>Email address: </strong>
                                              <a href="mailto:customerservice.anz@essity.com">customerservice.anz&#64;essity.com</a>
                                            </p>
                                          </div>
                                        </mat-card>
                                      </section>
